import { AfterViewInit,  ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RegionItem } from '@app/models/compass/RegionItem';
import { DynamicScriptLoaderService } from '@app/services/dynamicScriptLoader.service';
declare var echarts;
@Component({
    selector: 'app-inzidenz',
    templateUrl: './inzidenz.component.html',
    styleUrls: ['./inzidenz.component.scss'],
    standalone: false
})
export class InzidenzComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() currentRegionData!: RegionItem;
    @Input() chartOption!: any;

    inzidenzInfoAmpel: string = 'Tendenz Ampel - Mögliche Corona Inzidenz Entwicklung - Stand in 4 Wochen (Bemessungsgrundlagen: Entwicklung Inzidenzwerte der letzten 7 Tage, sowie die Entwicklung von Virusvarianten im Urlaubsgebiet). Alle Angaben ohne Gewähr und ohne Anspruch auf Richtigkeit oder Vollständigkeit';
    constructor (protected cdr: ChangeDetectorRef, private dynamicScriptLoader: DynamicScriptLoaderService) { }

    ngOnInit (): void {
        this.cdr.markForCheck();
    }

    ngAfterViewInit(): void {
        this.dynamicScriptLoader.load('echarts').then(data => {
            const ell = document.getElementById('inzidenzcharts');
            if (ell) {
                const myChart = echarts.init(ell);
                myChart.setOption(this.chartOption);
            }
        }).catch(error => console.log(error));
    }

    ngOnChanges (changes: SimpleChanges): void {
        this.cdr.markForCheck();
    }
}
